import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';

// components
import { FormInput } from 'components/form';

import { types } from 'utilities';


const AccountInformation: React.FC<types.IAccountInformation> = ({ userAttributes }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <form className="account-form">
      <Row className="align-items-center">
        <Col lg={6} className="ps-0">
          <FormInput
            type="text"
            label="Name"
            name="name.first"
            register={register}
            containerClass="mb-3"
            errors={errors}
          />
        </Col>
        <Col lg={6} className="ps-0">
          <FormInput
            type="text"
            label="Display name"
            name="display_name"
            register={register}
            containerClass="mb-3"
            errors={errors}
          />
        </Col>
      </Row>

      <Row>
        <Col lg={6} className="ps-0">
          <FormInput
            className="k-opac-60pc"
            type="email"
            label="Username"
            name="identifier"
            placeholder={userAttributes.identifier}
            defaultValue={userAttributes.identifier}
            register={register}
            disabled
            containerClass="mb-3"
            style={{ cursor: 'not-allowed' }}
          />
        </Col>
      </Row>
    </form>
  );
};


export default AccountInformation;
